import * as Updates from 'expo-updates';
import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import NetInfo, { NetInfoState } from '@/adapters/netinfo';
import React, { useEffect, useState } from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { SnapPeasCard } from '@/components/snap-peas-card';
import { TYPOGRAPHY } from '@/styles';

export const OfflineScreen: React.FC = () => {
  const [netInfoState, setNetInfoState] = useState<NetInfoState | null>(null);

  useEffect(() => {
    const reportScreen = async () => {
      const networkState = await NetInfo.fetch();
      setNetInfoState(networkState);
      Analytics.screen('offline_screen', undefined, {
        isConnected: networkState.isConnected,
        isReachable: networkState.isInternetReachable,
        type: networkState.type,
      });
    };

    reportScreen();
  }, []);

  return (
    <View style={styles.base}>
      <SnapPeasCard
        buttonProps={{
          children: i18n.t('retry'),
          onPress: () => {
            if (Platform.OS === 'web') {
              location.reload();
            } else {
              Updates.reloadAsync();
            }
          },
          trackingData: {
            name: 'network_status_error.retry_button',
            properties: {
              isConnected: netInfoState?.isConnected,
              isReachable: netInfoState?.isInternetReachable,
              type: netInfoState?.type,
            },
          },
        }}
      >
        <Text style={TYPOGRAPHY.cardMessageText}>
          {i18n.t('network_status_error')}
        </Text>
      </SnapPeasCard>
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
});
